module.exports = __webpack_public_path__ + "img/icon_map_13_on_111.79ba4549.png";